import { useState } from "react";
import Login from "../../pages/allocation/Login";
import Register from "../../pages/allocation/Register";

interface Props {
  onClose: () => void;
  hasCloseControl?: boolean;
}

const EmployeeAuthModal = ({ onClose, hasCloseControl = false }: Props) => {
  const [mode, setMode] = useState<"login" | "register">("login");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="relative">
        {hasCloseControl && (
          <div className="absolute w-8 h-8 flex items-center justify-center right-2 top-2 z-10 rounded-full bg-white/10 text-white hover:bg-white/20">
            <button
              onClick={onClose}
              className="w-full h-full"
              aria-label="Close modal"
            >
              ✕
            </button>
          </div>
        )}

        {mode === "login" ? (
          <Login onSwitch={() => setMode("register")} onClose={onClose} />
        ) : (
          <Register onSwitch={() => setMode("login")} />
        )}
      </div>
    </div>
  );
};

export default EmployeeAuthModal;
